import dynamic from "next/dynamic";
import Head from "next/head";
import "./sharevideo.module.scss";
const JWPlayer = dynamic(() => import("@jwplayer/jwplayer-react"), {
  ssr: false,
});

const ShareVideo = ({ newsData = null }) => {
  return (
    <>
      <Head>
        <meta name="googlebot" content="noindex,nofollow" />
        <meta name="robots" content="noindex, nofollow" />
      </Head>

      <div className="h-screen w-screen max-h-screen max-w-screen custom-player">
        <JWPlayer
          library={`https://cdn.jwplayer.com/libraries/${process.env.NEXT_PUBLIC_JW_PLAYER_ID}.js`}
          playlist={[
            {
              file: newsData?.hls_url[0]?.video_url,
              image: `${newsData?.image_main}?size=948:533`,
            },
          ]}
          className="h-full w-full"
          config={{
            mute: true,
            autoStart: true,
            pipIcon: true,
            generateSEOMetadata: true,
            fullscreenOrientationLock: "none",
          }}
        />
      </div>
    </>
  );
};

export default ShareVideo;
